import { get, put,Delete,post } from '../axios'

// 设备列表-列表
export const manageList = params => get(`/web/device/manage/list`,params);

// 内部参数-详情
export const manageView = params => get(`/web/device/manage/view/`+params,'');

// 内部参数-修改工厂模式指令
export const updateFactoryCommand = params => put(`/web/device/manage/updateFactoryCommand`,params);

// 内部参数-内部配置控制指令
export const updateInternalCommand = params => put(`/web/device/manage/updateInternalCommand`,params);

// 内部参数-修改合闸策略
export const updateCloseStrategy = params => put(`/web/device/manage/updateCloseStrategy`,params);

// 内部参数-修改单位开关定义
export const updateUnitSwitch = params => put(`/web/device/manage/updateUnitSwitch`,params);

// 内部参数-修改电流互感器方向
export const updateTransformer = params => put(`/web/device/manage/updateTransformer`,params);


